import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appOdometroHorimetroMask]'
})
export class OdometroHorimetroMaskDirective {

    constructor(
        private model: NgControl,
    ) {}

    @HostListener('ngModelChange', ['$event']) ngModelChange($event: any) {
        this.inputChange($event);
    }

    private inputChange(value: string) {
        if (value) {
            let newVal: string = value.toString();
            newVal = newVal.replace(/\D/g, '');
            newVal = Number(newVal).toString();

            if (newVal.length === 0 || !newVal || newVal === '0') {
                newVal = '';
            } else {
                if (newVal.length < 2) {
                    newVal = '0'.concat(newVal);
                }

                newVal = newVal.replace(/(\d{0,})(\d{1})/, "$1.$2");
            }

            this.model.valueAccessor.writeValue(newVal);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/directives/odometro-horimetro-mask.directive.ts
 **/